import { useCallback, useRef } from "react";

import { useAnimationFrame } from "./use-animation-frame";

type TargetElement = string | HTMLElement | null;

export function useAutoScrollToBottom(target: TargetElement) {
  const getElement = useCallback((): HTMLElement | null => {
    if (!target) return null;
    if (typeof target === "string") {
      return document.getElementById(target);
    }
    return target;
  }, [target]);

  const lastHeight = useRef(0);

  // Any time the height changes we scroll to bottom (same as github actions log)
  useAnimationFrame(() => {
    const el = getElement();
    if (!el) return;
    if (el.scrollHeight === lastHeight.current) return;
    lastHeight.current = el.scrollHeight;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, 10);
}
